module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 600,
      "persistent": ""
    },
    model: {
      value: (_vm.openModal),
      callback: function($$v) {
        _vm.openModal = $$v
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createGroup.apply(null, arguments)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text",
    staticStyle: {
      "position": "relative",
      "height": "100px"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("create")])], 1), _vm._v("\n            Group Cover Image\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "position": "absolute",
      "bottom": "-35px",
      "left": "20px"
    },
    attrs: {
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.groupPhotoUploaded = true
      }
    }
  }, [_c('div', {
    staticClass: "grey lighten-4 text-xs-center",
    staticStyle: {
      "height": "65px",
      "width": "65px",
      "border-radius": "10px"
    }
  }, [_c('v-icon', {
    staticClass: "secondary--text vertical-center"
  }, [_vm._v("assignment")])], 1), _vm._v(" "), (_vm.groupPhotoFile != '') ? _c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelGroupPhoto()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "50px",
      "height": "50px"
    },
    attrs: {
      "src": _vm.groupPhotoFileURL,
      "id": "imgActivity"
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-5"
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "white--text title-input",
    staticStyle: {
      "border": "1px solid rgba(255,255,255,0.2)"
    },
    attrs: {
      "required": "",
      "label": "Group Name",
      "prepend-icon": "create"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "rows": 3,
      "required": "",
      "multi-line": "",
      "label": "Type a decription for your group",
      "prepend-icon": "create"
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "required": "",
      "prepend-icon": "menu",
      "items": _vm.categories
    },
    model: {
      value: (_vm.group.category),
      callback: function($$v) {
        _vm.$set(_vm.group, "category", $$v)
      },
      expression: "group.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type keywords and press enter to add them",
      "prepend-icon": "assignment",
      "items": _vm.keywords,
      "chips": ""
    },
    model: {
      value: (_vm.group.keywords),
      callback: function($$v) {
        _vm.$set(_vm.group, "keywords", $$v)
      },
      expression: "group.keywords"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "label": "Select privacy",
      "required": "",
      "return-object": "",
      "items": [{
        text: 'Public Group',
        value: 1
      }, {
        text: 'Closed Group',
        value: 2
      }]
    },
    model: {
      value: (_vm.group.privacy),
      callback: function($$v) {
        _vm.$set(_vm.group, "privacy", $$v)
      },
      expression: "group.privacy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "red darken-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCreateGroupModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "type": "submit",
      "color": "blue darken-1"
    }
  }, [_vm._v("Create")])], 1), _vm._v(" "), _c('file-upload', {
    attrs: {
      "trigger": _vm.groupPhotoUploaded,
      "formats": ['jpeg', 'png', 'jpg']
    },
    on: {
      "update:trigger": function($event) {
        _vm.groupPhotoUploaded = $event
      },
      "cancel": _vm.cancel,
      "confirm": function($event) {
        return _vm.showGroupPhoto()
      }
    },
    model: {
      value: (_vm.groupPhotoFile),
      callback: function($$v) {
        _vm.groupPhotoFile = $$v
      },
      expression: "groupPhotoFile"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee4b31c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/createGroup.vue
// module id = 1655
// module chunks = 30